
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hk",
      function () {
        return require("private-next-pages/hk/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hk"])
      });
    }
  